import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "../PrivacyPolicy/styles.css";

/** 与 doc/伴知宠隐私政策摘要（已完成）.docx 中嵌入的 Microsoft_Excel_Worksheet1.xlsx 一致 */
const COLLECTION_TABLE_ROWS = [
  ["业务功能", "个人信息类型"],
  [
    "账户注册、登录与验证",
    "手机号码；您自主填写的信息（头像、昵称、性别、生日、地区）；第三方账号的公开信息（包括头像、昵称及您授权的其他信息）",
  ],
  [
    "宠物时光云相册",
    "您填写的宠物信息（宠物的名字、品种、生日、性别、头像、您与宠物的关系）；您自主发布的照片、视频、音频及对应的文字、评论、点赞；您授权后添加的位置信息；您访问相册的时间和次数（可关闭）；我们检测照片中是否包含人脸（不收集人脸信息）",
  ],
  [
    "AI问答",
    "您填写的宠物信息（宠物的名字、品种、生日、性别、头像、您与宠物的关系）；您输入的问题内容及上传的图片、语音数据；您的对话历史记录",
  ],
  [
    "智能硬件操控",
    "Wi-Fi网络信息（SSID、密码）；您手机的蓝牙、摄像头、麦克风、存储权限状态；操控指令及实时音视频流；设备环境信息、位置信息；异常检测触发的短时视频片段；共享用户的账号信息（昵称、头像）",
  ],
  [
    "附加功能（基于系统权限）",
    "您开启位置权限后收集的地理位置信息（用于发布时标记位置、填写收货地址、绑定设备）；您开启相机权限后拍摄的照片、视频；您开启存储/相册权限后上传的图片、视频及保存的文件；您开启麦克风权限后录制的音频、语音消息；您开启蓝牙权限后扫描和连接的智能设备信息",
  ],
  [
    "消息推送",
    "设备标识信息（Android ID、OAID、IDFA/IDFV）、推送令牌、设备型号、系统版本、网络类型及必要的网络信息，用于推送设备识别、消息下发、到达统计、排障及设备重启后恢复推送服务",
  ],
];

/** 与 doc/伴知宠隐私政策摘要（已完成）.docx 中嵌入的 Microsoft_Excel_Worksheet2.xlsx 一致 */
const PERMISSION_TABLE_ROWS = [
  ["权限类型", "用途说明"],
  [
    "相机权限",
    "用于拍摄照片、视频（发布时光云相册、更换头像/封面、AI问答上传图片、客服沟通、扫码关注），以及智能硬件远程实时预览画面",
  ],
  [
    "麦克风权限",
    "用于录制音频（时光云相册发布录音、拍摄视频时录入声音、AI问答语音输入、聊天时语音录入消息、与智能硬件进行双向语音对讲）",
  ],
  [
    "蓝牙权限",
    "用于扫描并连接附近的伴知宠智能设备（如智能陪伴车），以及在设备列表中获取智能设备信息",
  ],
  [
    "相册权限",
    "用于从本地相册上传照片/视频（发布时光云相册、更换头像/封面、AI问答上传图片、保存文件、回答/评论、客服沟通）",
  ],
  [
    "定位权限",
    "用于发布时光云相册记录时选择保存地理位置、通过位置信息辅助填写订单收货地址、扫描并绑定智能设备时获取附近的Wi-Fi信息",
  ],
  [
    "语音识别权限",
    "用于您主动选择使用语音录入消息时，将语音转换为文字",
  ],
];

function EmbedTable({ rows }) {
  const [header, ...body] = rows;
  return (
    <table className="summary-embed-table">
      <thead>
        <tr>
          {header.map((cell, i) => (
            <th key={i}>{cell}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {body.map((row, ri) => (
          <tr key={ri}>
            {row.map((cell, ci) => (
              <td key={ci}>{cell}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default function PrivacyPolicySummary() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      className="privacy-policy-page"
      style={{ padding: "16px 12px", maxWidth: "960px", margin: "0 auto" }}
    >
      <h1>伴知宠隐私政策摘要</h1>

      <p>
        伴知宠高度重视用户个人信息的合法使用和保护。本《伴知宠隐私政策摘要》旨在以简洁、清晰、易懂的方式向您介绍伴知宠App处理您个人信息的基本情况。如您需要了解完整的《伴知宠隐私政策》，可直接跳转至
        <Link to="/privacy-policy" className="policy-link">《伴知宠隐私政策》</Link>
      </p>

      <h2>我们如何收集和使用您的个人信息</h2>
      <p>下表为 Word 附带电子表格的网页版展示。</p>
      <EmbedTable rows={COLLECTION_TABLE_ROWS} />
      <p>
        详见
        <Link
          to="/privacy-policy/personal-info-collection-list"
          className="policy-link"
        >
          《个人信息收集清单》
        </Link>
      </p>
      <p>
        对于您在使用智能陪伴车和智能项圈等智能设备时收集和使用个人信息的详情，请见《伴知宠智能设备隐私政策》
      </p>

      <h2>我们可能需要开启哪些设备权限</h2>
      <p>
        我们的部分功能需要调用您的设备权限，例如相机权限、麦克风权限、蓝牙权限、相册权限、定位权限等。我们会采用系统弹窗或应用弹窗的方式询问您是否授权。您可以随时在伴知宠的设置选项或设备的设置功能中选择开关相关权限。
      </p>
      <p>下表为 Word 附带电子表格的网页版展示。</p>
      <EmbedTable rows={PERMISSION_TABLE_ROWS} />
      <p>
        更多详情请见我们的
        <Link to="/privacy-policy/app-permission-list" className="policy-link">
          《应用权限申请和使用情况说明》
        </Link>
        。您不同意开启特定权限通常只影响您使用其对应的特定功能。您可以在不开启相关权限的情况下使用基本功能。
      </p>

      <h2>我们如何共享您的信息</h2>
      <p>
        请您知悉，我们为您所提供的部分产品/服务是无法单独完成的，因此我们可能会与第三方合作商共享或委托其处理您的部分个人信息。目前，除再次获得您明确同意或授权外，此类共享或委托处理涉及的主要情形包括：根据行政、司法等有权机关的要求提供必要信息；为提供如配送、第三方支付等服务与有关合作商、支付机构等共享有关的必要信息等。
      </p>
      <p>
        我们会与其签署严格的信息保护和保密协定，要求他们遵守协议并采取相关的安全措施来保护您的个人信息。
      </p>
      <p>
        详情请见我们的
        <Link
          to="/privacy-policy/personal-info-sharing-list"
          className="policy-link"
        >
          《个人信息共享清单》
        </Link>
      </p>

      <h2>我们如何保存您的信息</h2>
      <p>保存位置：中国境内</p>
      <p>保存期限：为您提供伴知宠服务所必要和法律法规及监管规定要求的时限</p>
      <p>保存期满的处理方式：删除或进行匿名化处理</p>

      <h2>您如何管理您的信息</h2>
      <p>
        您可以在伴知宠的设置选项或者通过联系我们访问、修改、复制、删除您的个人信息；撤回您的同意；注销您的账号；或者行使其他法定的个人信息主体权利。
      </p>
    </div>
  );
}
